<template>
  <div>
    <ts-page-title
      :title="$t('courseSkill.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('courseSkill.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button type="primary" @click="addNew">
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end tw-space-x-2">
          <a-input
            v-model="search"
            v-tooltip="$t('courseSkill.search')"
            :placeholder="$t('courseSkill.search')"
            style="width: 250px"
            class="inline-block"
          />
          <a-button v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </a-button>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.branch.prefix_code }}
            </td>
            <td class="tw-whitespace-nowrap">{{ record.examination_event }}</td>
            <td class="tw-whitespace-nowrap">
              {{
                record.levelskill
                  ? record.levelskill.level_skill_name
                    ? record.levelskill.level_skill_name
                    : null
                  : null
              }}
              | Skill:
              {{ record.levelskill ? record.levelskill.skill_name_en : null }} |
              LeveL:
              {{
                record.levelskill ? record.levelskill.skill_level_order : null
              }}
              <span
                v-if="record.levelskill ? record.levelskill.is_accessor : false"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </td>
            <td class="text-center tw-whitespace-nowrap">{{ record.room }}</td>
            <td class="text-center tw-whitespace-nowrap">
              <span
                class="tw-bg-blue-400 tw-rounded-full tw-px-1 tw-font-semibold"
                >{{ record.exam_registers_count }}</span
              >
              <!-- {{ record.exam_registers_count }} -->
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.trainer.full_name_en }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.trainer2 ? record.trainer2.full_name_en : "" }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.trainer3 ? record.trainer3.full_name_en : "" }}
            </td>
            <td class="tw-w-32 tw-text-center">
              <!-- <span class="badge bg-success" v-if="!record.is_closed"
                >Open</span
              >
              <span class="badge bg-danger" v-else>Close</span> -->

              <a-popconfirm
                placement="leftTop"
                :title="$t('courseSkill.are_you_sure_update')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="changeStatue(record)"
                @cancel="record.is_closed = !record.is_closed"
              >
                <a-switch
                  :loading="waiting"
                  v-model="record.is_closed"
                  size="small"
                />
              </a-popconfirm>
            </td>
            <td class="text-center tw-space-x-3 tw-whitespace-nowrap">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-drawer
      :title="$t('filter')"
      :closable="false"
      :visible="visible"
      :zIndex="1020"
      @close="() => (visible = false)"
      width="300px"
    >
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t("testingCenter")
        }}</label>
        <ts-branch-filter @filter="(value) => (branch_id = value)" />
      </div>
      <div class="mb-3">
        <ts-checkbox v-model="closed" @change="fetchData()"
          >Is Closed</ts-checkbox
        >
      </div>
    </a-drawer>
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('courseSkill.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
import FromAction from "./form.vue";
export default {
  name: "courseSkillIndex",
  components: {
    FromAction,
  },
  data() {
    return {
      loading: false,
      showForm: false,
      visible: false,
      branch_id: [],
    };
  },
  computed: {
    ...mapState("academic/courseSkill", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.academic.courseSkill.search;
      },
      set(newValue) {
        this.$store.commit("academic/courseSkill/SET_SEARCH", newValue);
        this.$store.commit("academic/courseSkill/RESET_CURRENT_PAGE");
      },
    },
    closed: {
      get() {
        return this.$store.state.academic.courseSkill.is_closed;
      },
      set(newValue) {
        this.$store.commit("academic/courseSkill/SET_STATUS", newValue);
      },
    },
    columns() {
      return [
        {
          name: this.$t("courseSkill.testingCenter"),
          style: "text-align:center;width:150px;white-space: nowrap;",
        },
        {
          name: this.$t("courseSkill.examinationEvent"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("courseSkill.skill"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("courseSkill.room"),
          style: "text-align:center;white-space: nowrap;width:200px",
        },
        {
          name: this.$t("courseSkill.numberOfCandidate"),
          style: "text-align:center;white-space: nowrap;width:200px",
        },
        {
          name: this.$t("courseSkill.trainer"),
          style: "white-space: nowrap;width:300px",
        },
        {
          name: this.$t("courseSkill.trainer2"),
          style: "white-space: nowrap;width:300px",
        },
        {
          name: this.$t("courseSkill.trainer3"),
          style: "white-space: nowrap;width:300px",
        },
        {
          name: this.$t("courseSkill.isClosed"),
          style: "white-space: nowrap;width:50px;text-align:center",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 1px;white-space: nowrap;",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/courseSkill/fetch", {
          ...attributes,
          branch_id: this.branch_id,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    addNew() {
      this.showForm = true;
    },
    edit(record) {
      this.$store.commit("academic/courseSkill/SET_EDIT_DATA", record);
      this.showForm = true;
    },
    clearEdit() {
      this.$store.commit("academic/courseSkill/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
    changeStatue(record) {
      this.$store
        .dispatch("academic/courseSkill/changeStatue", {
          id: record.course_skill_id,
          data: { is_closed: record.is_closed },
        })
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch("academic/courseSkill/destroy", record.course_skill_id)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value });
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/courseSkill/RESET_STATE");
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
};
</script>
